export default __webpack_public_path__ + "static/media/LOGO-CONMED-WHITE.99b425e0.png";